import React from 'react';
import FeatureGatedUserRolesPicker from '@atlassian/jira-feature-gates-tmp-access/src/ui/feature-gated-roles-picker/index.tsx';
import { JswFreeConditionalRenderer } from '@atlassian/jira-jsw-feature-gates/src/ui/index.tsx';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { PACKAGE_NAME } from '../../../common/constants';
import PermissionsGatedRole from './permission-gated-role/main.tsx';
import RolesPickerContainer from './roles-picker-container';
import type { Props } from './types';

export const RoleCell = (props: Props) => {
	const { hasPermissionsGate, actor, projectRoles, onRolesUpdated, applicationName } = props;
	if (hasPermissionsGate) {
		return (
			<JswFreeConditionalRenderer
				renderJswFree={() => <FeatureGatedUserRolesPicker actor={actor} roles={projectRoles} />}
				// There is also permission/feature gate for JWM, which `FeatureGatedUserRolesPicker` currently does not support
				renderElse={() => (
					<>
						<FireUiAnalytics action="viewed" actionSubject="permissionGatedRole" />
						<div data-pollinator-permissions-gated-role>
							<PermissionsGatedRole
								shouldFitContainer
								actor={actor}
								roles={projectRoles}
								applicationName={applicationName}
							/>
						</div>
					</>
				)}
				caller={PACKAGE_NAME}
			/>
		);
	}

	return (
		<RolesPickerContainer actor={actor} roles={projectRoles} onRolesUpdated={onRolesUpdated} />
	);
};

export default RoleCell;
